import { z } from "zod";

/** E-Tariff Exclusion Request state machine — code-verified names/spelling
 * preserved verbatim (COMPLIANCE_REVIEWER_APPROVED corrects the legacy's
 * misspelled COMPLAINCE_REVIEWER_APPROVED for the target build). */
export const EXCLUSION_STATUSES = [
  "NEW",
  "PLANT_APPROVER_APPROVED_NEW",
  "COMPLIANCE_REVIEWER_APPROVED",
  "EXCLUSION_ADMIN_APPROVED",
  "REJECTED",
  "RENEWED",
  "PLANT_APPROVER_APPROVED_RENEW",
] as const;
export type ExclusionStatus = (typeof EXCLUSION_STATUSES)[number];

export const exclusionRequestCreateSchema = z.object({
  htsCode: z.string().min(1),
  productDescription: z.string().min(1),
  plantId: z.number().int(),
  requestedExpiry: z.string(),
  annualExclusionQty: z.number().nonnegative().optional(),
  chemicalComposition: z.record(z.string(), z.number()).optional(),
  justification: z.string().optional(),
});
export type ExclusionRequestCreateInput = z.infer<typeof exclusionRequestCreateSchema>;

export const exclusionApprovalSchema = z.object({
  requestId: z.number().int(),
  decision: z.enum(["approve", "reject"]),
  comment: z.string().optional(),
});

export const exclusionErNumberSchema = z.object({
  requestId: z.number().int(),
  erNumber: z.string().min(1),
  volumeConsumed: z.number().nonnegative(),
  volumeRemaining: z.number().nonnegative(),
});
